import { createContext, useContext, useState } from "react";

const STORAGE_KEY = "prosperaPerspective";

export const PERSPECTIVES = {
  "build-scale": { label: "Build & Scale" },
  "transform-optimize": { label: "Transform & Optimize" },
  explore: { label: "Exploring Prospera" },
};

const readStored = () => {
  try {
    const v = window.localStorage.getItem(STORAGE_KEY);
    return v && PERSPECTIVES[v] ? v : null;
  } catch (err) {
    console.warn("Perspective storage unavailable, falling back to session state:", err);
    return null;
  }
};

const PerspectiveContext = createContext(null);

export const PerspectiveProvider = ({ children }) => {
  const [perspective, setPerspectiveState] = useState(readStored);

  const setPerspective = (value) => {
    setPerspectiveState(value);
    try {
      window.localStorage.setItem(STORAGE_KEY, value);
    } catch (err) {
      console.warn("Could not persist perspective; state still works for this visit:", err);
    }
  };

  return (
    <PerspectiveContext.Provider value={{ perspective, setPerspective }}>
      {children}
    </PerspectiveContext.Provider>
  );
};

export const usePerspective = () => useContext(PerspectiveContext);
